import IconPickerWithRemoveButton from 'client/components/core/Sidebar/components/Settings/components/IconPickerWithRemoveButton'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import React, {} from 'react'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import {
  FormFieldInterface,
  FormSubentityTypeEnum,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { useUpdateFormSubentityProp } from '../../hooks/use-update-form-subentity-prop'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import { FormSubentityCommonSettingsButtonLink } from './form-subentity-common-settings-button-link'
import { SidebarBottomPortal } from 'src/editor/layout/sidebar/settings/sidebar-bottom-portal'

export const FormFieldSubentitySettings = ({
  formEntity,
  fieldSubentity,
}: {
  formEntity: FormInterface
  fieldSubentity: FormFieldInterface
}) => {
  const updateProp = useUpdateFormSubentityProp(formEntity, fieldSubentity)

  const isMandatoryType = fieldSubentity.slug === ContactSlugEnum.Email
  const isOptionalType =
    fieldSubentity.slug === ContactSlugEnum.TaxNumber ||
    fieldSubentity.slug === ContactSlugEnum.CompanyName

  const isOptionalSettingAvailable = !isMandatoryType && !isOptionalType

  return (
    <>
      {fieldSubentity.slug !== ContactSlugEnum.Country &&
        fieldSubentity.slug !== ContactSlugEnum.PhoneNumber && (
          <TextInputControl
            wrapperProps={{
              labelText: 'entity_settings.field.placeholder.label',
            }}
            value={fieldSubentity.placeholder}
            update={updateProp('placeholder')}
            type="text"
          />
        )}
      {isOptionalSettingAvailable && (
        <CheckboxControl
          label="entity_settings.field.optional"
          tooltipText="entity_settings.field.optional_popover"
          value={fieldSubentity.optional}
          update={updateProp('optional')}
        />
      )}
      {fieldSubentity.slug !== ContactSlugEnum.Country && (
        <IconPickerWithRemoveButton
          label="entity_options.icon_picker.title"
          value={fieldSubentity.iconClassName}
          update={updateProp('iconClassName')}
        />
      )}
      <HtmlAttrId attrId={fieldSubentity.htmlAttrId} />

      <SidebarBottomPortal>
        <FormSubentityCommonSettingsButtonLink
          formEntity={formEntity}
          commonSettingsType={FormSubentityTypeEnum.Field}
        />
      </SidebarBottomPortal>
    </>
  )
}
